module.exports = __webpack_public_path__ + "static/media/c3b_Ramana-Naidu@3x.6971c400.png";